import React from 'react';
import PropTypes from 'prop-types';

import { Menu as MUIMenu } from '@material-ui/core';

export const Menu = props => <MUIMenu {...props} />;

Menu.propTypes = {
  anchorEl: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  anchorOrigin: PropTypes.object,
  children: PropTypes.node,
  getContentAnchorEl: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  keepMounted: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  transformOrigin: PropTypes.object
};

export default Menu;
